
import Vue from 'vue';
import { TranslateResult } from 'vue-i18n';

import {
  googleFormStudentWorkabilitySurvey,
  googleFormStudentSocioEconomicSurvey,
} from '@/settings/constants';

enum SurveyType {
  Workability = 'trabalhabilidade',
  SocioEconomic = 'socioeconomica',
}

function isValidSurveyType(surveyType: unknown): boolean {
  switch (surveyType as SurveyType) {
    case SurveyType.Workability:
      return true;
    case SurveyType.SocioEconomic:
      return true;
    default:
      return false;
  }
}

export default Vue.extend({
  beforeRouteEnter(to, _from, next) {
    if (!isValidSurveyType(to.params.name)) {
      return next(false);
    }

    return next();
  },
  computed: {
    surveyTitle(): TranslateResult {
      const surveyType = this.$route.params.name;

      if (SurveyType.Workability === surveyType) {
        return this.$t('survey.title', { subTitle: this.$tc('survey.workability') });
      }

      return this.$t('survey.title', { subTitle: this.$tc('survey.socioEconomic') });
    },
    surveyFormUrl(): string {
      const surveyType = this.$route.params.name;
      const { email } = this.$store.getters.currentUser;

      if (SurveyType.Workability === surveyType) {
        return googleFormStudentWorkabilitySurvey.replace('[EMAIL]', encodeURIComponent(email));
      }

      return googleFormStudentSocioEconomicSurvey.replace('[EMAIL]', encodeURIComponent(email));
    },
  },
});
